import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md slide-up">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-3">
            <img src="/force2-logo.png" alt="Force2 Telecom" className="w-20 h-20 object-contain rounded-lg bg-slate-900 border border-slate-800 p-1" />
          </div>
          <h1 className="font-display font-black text-3xl tracking-tight text-slate-50">FORCE2 FIELDOPS</h1>
          <div className="text-xs tracking-[0.3em] uppercase text-slate-400 mt-1">Telecom · Field Operations Platform</div>
        </div>

        <Card className="bg-slate-900 border-slate-800">
          <div className="brand-bar" />
          <CardContent className="p-6 sm:p-8">
            <form onSubmit={submit} className="space-y-4" data-testid="login-form">
              <div>
                <Label htmlFor="email" className="text-slate-300 font-display tracking-wide text-xs uppercase">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1.5 bg-slate-950 border-slate-700 text-slate-100"
                  data-testid="login-email"
                />
              </div>
              <div>
                <Label htmlFor="password" className="text-slate-300 font-display tracking-wide text-xs uppercase">Password</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mt-1.5 bg-slate-950 border-slate-700 text-slate-100"
                  data-testid="login-password"
                />
              </div>
              <Button
                type="submit"
                disabled={busy}
                className="w-full bg-red-700 hover:bg-red-600 font-display tracking-[0.15em] text-sm h-11"
                data-testid="login-submit"
              >
                {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ShieldCheck className="w-4 h-4 mr-2" />}
                SIGN IN
              </Button>
              <div className="text-center text-xs text-slate-500 pt-2">
                Don't have an account? Ask your administrator to create one.
              </div>
            </form>
          </CardContent>
        </Card>

        <div className="mt-6 text-center text-[10px] tracking-[0.3em] uppercase text-slate-600">
          Microsoft 365 sign-in coming soon
        </div>
      </div>
    </div>
  );
}
